module.exports = __webpack_public_path__ + "fonts/NotoSans-SemiBold.eot";